import React from "react";
import Recaptcha from "react-google-recaptcha";
import { Container } from "react-bootstrap";
import { FormattedMessage, useIntl } from "react-intl";

import PanelWrapper from "../../internal/panelWrapper/PanelWrapper";
import { EncodeFormData } from "../FormHelpers";
import { GetRecaptchaKey } from "../../../utils/env";

import * as styles from "../GeneralFormStyles.module.scss";
import { resolveRichText } from "../../../utils/richText";

const CopperContactForm = ({ blok }) => {

  const intl = useIntl();
  const [showSuccess, setShowSuccess] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState("");

  const [state, setState] = React.useState({});
  const recaptchaRef = React.createRef();
  const [buttonDisabled, setButtonDisabled] = React.useState(true);

  const handleChange = e => {
    setState({ ...state, [e.target.name]: e.target.value });
  };
  

  const handleSubmitForm = (e) => {
    const recaptchaValue = recaptchaRef.current.getValue();
    ResolveSubmitForm(e, setErrorMessage, setIsLoading, setShowSuccess, recaptchaValue, state, intl)
  };

  const success_message = resolveRichText(blok.success_message)
  return (
    <PanelWrapper blok={blok}>
      <Container>
        {showSuccess ? (
          <div className={styles.success}>
            <br />
            <br />
              {success_message ? <div dangerouslySetInnerHTML={success_message}></div> : <FormattedMessage id="component.form.contact_form.success_message" />}
          </div>
        ) : (
          <form
            name="copper-contact"
            data-netlify="true"
            data-netlify-recaptcha="true"
            onSubmit={handleSubmitForm}
            className={styles.formWrapper}
            method="POST"
          >
            <noscript>
        <p>This form won't work with Javascript disabled</p>
      </noscript>
            <input type="hidden" name="form-name" value="copper-contact" />
            <div className={styles.formInput}>
              <label htmlFor="contact_name">
                <FormattedMessage id="component.form.contact_form.name_label" />
                &nbsp;<span className={styles.textGreen}>*</span>
              </label>
              <input
                id="contact_name"
                type="text"
                name="name"
                required
                placeholder={
                  intl.messages["component.form.contact_form.name_placeholder"]
                }
                onChange={handleChange}
                disabled={isLoading}
              />
            </div>
            <div className={styles.formInput}>
              <label htmlFor="contact_email">
                <FormattedMessage id="component.form.contact_form.email_label" />
                &nbsp;<span className={styles.textGreen}>*</span>
              </label>
              <input
                id="contact_email"
                type="email"
                name="email"
                required
                placeholder={
                  intl.messages["component.form.contact_form.email_placeholder"]
                }
                onChange={handleChange}
                disabled={isLoading}
              />
            </div>
            
            <div className={styles.formInput}>
              <label htmlFor="contact_company">
                <FormattedMessage id="component.form.contact_form.company_label" />
              </label>
              <input
                id="contact_company"
                type="text"
                name="company"
                placeholder={
                  intl.messages[
                    "component.form.contact_form.company_placeholder"
                  ]
                }
                onChange={handleChange}
                disabled={isLoading}
              />
            </div>
            <div className={styles.formInput}>
              <label htmlFor="contact_message">
                <FormattedMessage id="component.form.contact_form.message_label" />
              </label>
              <textarea
                id="contact_message"
                rows="5"
                name="message"
                placeholder={
                  intl.messages[
                    "component.form.contact_form.message_placeholder"
                  ]
                }
                onChange={handleChange}
                disabled={isLoading}
              ></textarea>
            </div>
            {errorMessage ? (
              <p className={styles.error}>{errorMessage}</p>
            ) : null}
            <Recaptcha 
              ref={recaptchaRef}
              sitekey={GetRecaptchaKey()}
              size="normal"
              id="recaptcha-google"
              onChange={() => setButtonDisabled(false)}
          />
            <div style={{ textAlign: "center", paddingTop: "40px" }}>
              <button
                type="submit"
                disabled={buttonDisabled}
                className={styles.btnSolidBlue}
              >
                <FormattedMessage id="component.form.contact_form.submit_text" />
              </button>
            </div>
          </form>
        )}
      </Container>
      </PanelWrapper>
  );
};

export default CopperContactForm;
